(async function () {
  // Taros mokesčio varianto ID
  const feeVariantId = 48213164622161;

  const getCart = async () => {
    const response = await fetch("/cart.json");
    const data = await response.json();
    return data;
  };

  const getBeverageCount = (cart) => {
    const beverageCount = cart.items.reduce((acc, item) => {
    const productTitle = item.product_title.toLowerCase();
    if ((productTitle.includes("gėrimas") || productTitle.includes("rinkinys")) && productTitle !== "tinktūrų rinkinys, gauk 1 nemokamai") {
      return acc + item.quantity;
      }
      return acc;
    }, 0);
    return beverageCount;
  };

  const addFee = async (count) => {
    if (count > 0) {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: feeVariantId,
          quantity: count,
        }),
      });
    }
  };

  const updateFee = async (count) => {
    let updates = {};
    updates[feeVariantId] = count;

    await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    });
  };

  const removeFee = async () => {
    let updates = {};
    updates[feeVariantId] = 0;

    await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    });
  };

  const cartHasFee = (cart) => {
    return cart.items.some((item) => item.variant_id === feeVariantId);
  };

  const setFee = async (count, cart) => {
    if (count > 0) {
      if (cartHasFee(cart)) {
        await updateFee(count);
      } else {
        await addFee(count);
      }
    } else if (cartHasFee(cart)) {
      await removeFee();
    }
  };

  const initializeSlider = () => {
    const $cartPro = $('.cart-pro');
    if (!$cartPro.hasClass('slick-initialized')) {
      $cartPro.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        variableWidth: true,
        infinite: false,
        draggable: false,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              infinite: false,
              draggable: false,
              slidesToScroll: 1,
            }
          }
        ]
      });

      const cartPro = document.querySelector('.cart-pro');
      const loading1 = document.querySelector('.loading1');
      if (loading1) {
        loading1.style.display = 'none';  
      }
      if (cartPro) {
        cartPro.style.display = 'flex'; 
      }
    }
  };

  const reloadCart = async () => {
    document.dispatchEvent(new CustomEvent("theme:cart:reload"));
    setTimeout(initializeSlider, 1000);
  };

  const onCartChange = async (cart) => {
    const beverageCount = getBeverageCount(cart);
    await setFee(beverageCount, cart);
    reloadCart();
  };

  let cartChanged = false;
  let lastCart = null;
  document.addEventListener("theme:cart:change", async () => {
    cartChanged = true;
  });

  setInterval(async () => {
    if (cartChanged) {
      cartChanged = false;
      const cart = await getCart();
      if (JSON.stringify(cart) !== JSON.stringify(lastCart)) {
        lastCart = cart;
        await onCartChange(cart);
      }
    }
  }, 1000);

  $(".cart__items__remove").on("click", async () => {
    document.dispatchEvent(
      new CustomEvent("theme:cart:change", {
        detail: { cart: await getCart() },
      })
    );
  });

  $(".collection-product__quick-add").on("click", async function() {
  const $button = $(this);
  const variantId = $button.attr("variant-id");

  $button.addClass("loading");

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1, 
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to add product to cart.");
    }

    $button.removeClass("loading");

    const cart = await getCart();

    document.dispatchEvent(
      new CustomEvent('theme:cart:change', {
        detail: { cart },
        bubbles: true,
      })
    );

    if (cart.items.length > 0) {
      await onCartChange(cart);
    }

    } catch (error) {
    console.error("Error adding product to cart:", error);
    $button.removeClass("loading");
  }
});

})();
